import { render, staticRenderFns } from "./TwSubtaskIcon.vue?vue&type=template&id=7228a7f6&scoped=true&"
import script from "./TwSubtaskIcon.vue?vue&type=script&lang=js&"
export * from "./TwSubtaskIcon.vue?vue&type=script&lang=js&"
import style0 from "./TwSubtaskIcon.vue?vue&type=style&index=0&id=7228a7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228a7f6",
  null
  
)

export default component.exports